module.exports = __webpack_public_path__ + "static/images/three-dots-v2.1tkUwbH.svg";